export const compareByName = (a: { name: string }, b: { name: string }): number => (
	a.name.localeCompare(b.name)
);

export const identityFunction = <T>(arg: T): T => arg;